export default {
  createHeader: 'Ereignis-Schlagwort erstellen',
  editHeader: 'Ereignis-Schlagwort bearbeiten',
  duplicateDisplayName: 'Ein Schlagwort mit diesem Namen existiert bereits.',
};
